module.exports = __webpack_public_path__ + "img/bookmark_off.55635de0.svg";